<template>
  <v-container class="py-12 py-lg-16">
    <v-row>
      <v-col cols="12" lg="3">
        <h3 class="text-h6 font-weight-medium text-white">Contact Us</h3>

        <p class="text-body-1 text-white font-weight-medium mt-4">
          Headquartered in Silicon Valley / San Francisco Bay Area
        </p>

        <p class="text-body-1 text-white text-medium-emphasis mt-2">
          <a
            class="unified-footer-contact-link text-white text-medium-emphasis text-decoration-underline"
            href="tel:+19252899001"
          >
            +1 (925) 289-9001
          </a>
          <br />
          <a
            class="unified-footer-contact-link text-white text-medium-emphasis text-decoration-underline"
            href="mailto:info@hyperdriveagile.com"
          >
            info@hyperdriveagile.com
          </a>
        </p>

        <v-btn
          :append-icon="mdiArrowRight"
          class="text-none font-weight-bold mt-8"
          color="light-blue-darken-2"
          exact
          href="/contact"
          rounded="pill"
          size="x-large"
        >
          Contact Us
        </v-btn>
      </v-col>

      <v-col cols="12" lg="3">
        <h3 class="text-h6 font-weight-medium text-white">
          Business Transformation
        </h3>
        <ul class="unified-footer-nav-list mt-4 pa-0">
          <li
            v-for="item in col1Links"
            :key="item.href"
            class="unified-footer-nav-item"
          >
            <a
              :href="item.href"
              class="unified-footer-nav-link text-body-1 text-light-blue-lighten-4 text-decoration-none"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </v-col>

      <v-col cols="12" lg="3">
        <h3 class="text-h6 font-weight-medium text-white">
          Training &amp; Resources
        </h3>
        <ul class="unified-footer-nav-list mt-4 pa-0">
          <li
            v-for="item in col2Links"
            :key="item.href"
            class="unified-footer-nav-item"
          >
            <a
              :href="item.href"
              class="unified-footer-nav-link text-body-1 text-light-blue-lighten-4 text-decoration-none"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </v-col>

      <v-col class="mt-8 mt-lg-0" cols="12" lg="3">
        <h3 class="text-h6 font-weight-medium text-white">Stay Connected</h3>
        <p class="text-body-1 text-white text-medium-emphasis mt-4">
          Get practical insights on business agility, leadership, and
          transformation, plus updates on upcoming courses, workshops, and
          events.
        </p>
        <v-btn
          :append-icon="mdiArrowRight"
          class="text-none font-weight-bold mt-6"
          color="white"
          href="/subscribe"
          rounded="pill"
          size="x-large"
          variant="outlined"
        >
          Sign Up
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-divider class="my-4" color="white" opacity="0.2" />
      </v-col>
    </v-row>

    <v-row align="center">
      <v-col cols="12" md="4">
        <p class="text-body-2 text-white text-medium-emphasis">
          {{ copyrightNotice }}
        </p>
      </v-col>

      <v-col v-if="siteConfig?.social_info" align="center" cols="12" md="4">
        <SocialButtons :value="siteConfig.social_info" color="white" />
      </v-col>

      <v-col class="text-md-right" cols="12" md="4">
        <p class="text-body-2 text-white text-medium-emphasis">
          Hyperdrive Agile Leadership is part of the Bratton &amp; Co. family of
          Agile leadership organizations.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed } from 'vue'
import { mdiArrowRight } from '@mdi/js'
import { usePageContext } from '#root/renderer/usePageContext'

const { siteConfig } = usePageContext()

const col1Links = [
  {
    label: 'Business Strategy & Leadership',
    href: '/explore/business-strategy-and-leadership'
  },
  {
    label: 'Business Transformation',
    href: '/explore/business-transformation'
  },
  { label: 'OKR Coaching', href: '/explore/okr-coaching' },
  { label: 'Business Agility', href: '/explore/business-agility' },
  { label: 'Product & Innovation', href: '/explore/product-and-innovation' },
  {
    label: 'People & Organizational Performance',
    href: '/explore/people-and-organizational-performance'
  }
]

const col2Links = [
  { label: 'Group & Private Training', href: '/training/agile-teams' },
  { label: 'Certified Courses Overview', href: '/training/courses' },
  { label: 'Workshops Overview', href: '/training/workshops' },
  { label: 'On-Demand Overview', href: '/training/on-demand' },
  { label: 'Privacy Policy', href: '/legal/privacy-policy' },
  { label: 'Terms of Service', href: '/legal/terms' }
]

const copyrightNotice = computed(
  () =>
    `Copyright © ${new Date().getFullYear()} Bratton & Co. All rights reserved.`
)
</script>

<style scoped>
.unified-footer-nav-list {
  list-style: none;
}

.unified-footer-nav-item + .unified-footer-nav-item {
  margin-top: 8px;
}

.unified-footer-nav-link:hover,
.unified-footer-contact-link:hover {
  color: #fff !important;
}
</style>
